import React, { useState, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaFileAlt, FaSearch, FaTrash } from "react-icons/fa";
import "../CSS/LaporanKendalaTeknis.css";

const API_URL = "https://api-tibismart.tifpsdku.com/api/laporan/admin/all";


// =============================
const normalizeStatus = (status) => {
  if (!status) return "Menunggu";

  const s = status.toLowerCase();
  if (s === "diterima") return "Menunggu";
  if (s === "menunggu") return "Menunggu";
  if (s === "proses") return "Proses";
  if (s === "selesai") return "Selesai";

  return "Menunggu";
};


function LaporanKendalaTeknisAdmin() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [filterJenis, setFilterJenis] = useState("All");

  // =============================
  // FETCH DATA
  // =============================
  useEffect(() => {
    fetchLaporan();
  }, []);

  const fetchLaporan = async () => {
    try {
      const res = await axios.get(API_URL);


      const mappedData = res.data.map((item) => ({
        id: item.id_laporan,
        nama: item.nama_pelapor,
        role: item.role,
        jenis: item.jenis_kendala,
        email: item.email,
        deskripsi: item.deskripsi_kendala,
        status: normalizeStatus(item.status),
        tanggal: item.tanggal_lapor,
      }));

      setData(mappedData);
    } catch (err) {
      console.error("Gagal mengambil data laporan", err);
    }
  };

  // FILTER + SEARCH (TIDAK DIUBAH)
  // =============================
  const filtered = useMemo(() => {
    return data.filter((item) => {

      // Filter berdasarkan role
      const matchRole =
        filterJenis === "All"
          ? true
          : item.role === filterJenis;

      // Search
      const q = search.trim().toLowerCase();
      const matchSearch =
        !q ||
        item.nama.toLowerCase().includes(q) ||
        item.email.toLowerCase().includes(q) ||
        item.role.toLowerCase().includes(q) ||
        item.deskripsi.toLowerCase().includes(q);

      return matchRole && matchSearch;
    });
  }, [search, filterJenis, data]);

  // ================= PAGINATION =================
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  const currentRows = filtered.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.max(
    1,
    Math.ceil(filtered.length / rowsPerPage)
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [search, filterJenis]);


  // ACTION
  // =============================
  const handleDetail = (id) => {
    navigate(`/HalamanTindakLanjut/${id}`);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Yakin ingin menghapus laporan ini?")) return;

    try {
      await axios.delete(`https://api-tibismart.tifpsdku.com/api/laporan/${id}`);
      setData((prev) => prev.filter((item) => item.id !== id));
    } catch (err) {
      alert("Gagal menghapus laporan");
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      await axios.put(`https://api-tibismart.tifpsdku.com/api/laporan/${id}/status`, {
        status: newStatus,
      });

      setData((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, status: newStatus } : item
        )
      );
    } catch (err) {
      alert("Gagal mengubah status");
    }
  };

  // =============================
  // RENDER (DESAIN ASLI)
  // =============================
  return (
    <div className="laporan-page">
      <div className="laporan-header">
        <div className="laporan-controls">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="filter-boxkendala">
            <select
              value={filterJenis}
              onChange={(e) => setFilterJenis(e.target.value)}
            >
              <option value="All">Semua</option>
              <option value="Dokter Paru">Dokter Paru</option>
              <option value="Tenaga Kesehatan">Radiolog</option>
            </select>
          </div>
        </div>
      </div>

      <div className="table-wrapper-laporan">
        <table className="laporan-table">
          <thead>
            <tr>
              <th>No</th>
              <th>Nama Pelapor</th>
              <th>Jenis Kendala</th>
              <th>Email</th>
              <th>Deskripsi Kendala</th>
              <th>Status Kendala</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.map((row, idx) => (
              <tr key={row.id}>
                <td>{indexOfFirstRow + idx + 1}</td>
                <td>{row.nama}</td>
                <td>{row.jenis}</td>
                <td>{row.email}</td>
                <td className="desc-cell">{row.deskripsi}</td>
                <td>
                  <select
                    className={`status-dropdown ${row.status.toLowerCase()}`}
                    value={row.status}
                    onChange={(e) =>
                      handleStatusChange(row.id, e.target.value)
                    }
                  >
                    <option value="Menunggu">Menunggu</option>
                    <option value="Proses">Proses</option>
                    <option value="Selesai">Selesai</option>
                  </select>
                </td>
                <td>
                  <button
                    className="detail-btn"
                    onClick={() => handleDetail(row.id)}
                    title="Detail"
                  >
                    <FaFileAlt />
                  </button>

                  <button
                    className="hapus-btn"
                    onClick={() => handleDelete(row.id)}
                    title="Hapus"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}

            {filtered.length === 0 && (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                  Tidak ada data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>


      <div className="pagination">

        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          Prev
        </button>

        {(() => {
          const pages = [];
          const maxVisible = 5;

          let start = Math.max(1, currentPage - 2);
          let end = Math.min(totalPages, start + maxVisible - 1);

          if (end - start < maxVisible - 1)
            start = Math.max(1, end - maxVisible + 1);

          if (start > 1) {
            pages.push(
              <button key={1} onClick={() => setCurrentPage(1)}>
                1
              </button>
            );

            if (start > 2)
              pages.push(<span key="dots1">...</span>);
          }

          for (let i = start; i <= end; i++) {
            pages.push(
              <button
                key={i}
                className={currentPage === i ? "active" : ""}
                onClick={() => setCurrentPage(i)}
              >
                {i}
              </button>
            );
          }

          if (end < totalPages) {

            if (end < totalPages - 1)
              pages.push(<span key="dots2">...</span>);

            pages.push(
              <button
                key={totalPages}
                onClick={() => setCurrentPage(totalPages)}
              >
                {totalPages}
              </button>
            );
          }

          return pages;

        })()}

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          Next
        </button>

      </div>

      <footer className="laporan-footer">
        © 2025 TibiSmart. All rights reserved.
      </footer>
    </div>
  );
}

export default LaporanKendalaTeknisAdmin;
